import { Drawer, Hidden, IconButton, makeStyles } from "@material-ui/core";
import { ExpandLessRounded } from "@material-ui/icons";
import { useState } from "react";
import FooterBar from './FooterBar';

const Footer = ({ children }) => {
    const useStyles = makeStyles(theme => ({
        phantom: {
            display: 'block',
            width: '100%',
        },
        privacyButton: {
            position: "fixed",
            display: 'flex',
            left: '50%',
            bottom: 0,
            marginLeft: -35,
            marginTop: -35,
            height: 70,
            width: 70
        },
        break: {
            width: '100%'
        }
    }));

    const [footer, setFooter] = useState(false);

    const showFooter = () => {
        setFooter(!footer);
    };

    const classes = useStyles();

    return (
        <div className="footer">
            <div className={classes.phantom} />
            <Hidden smDown>
                <FooterBar/>
            </Hidden>
            <Hidden mdUp>
                <IconButton size='medium' className={classes.privacyButton} onClick={showFooter}>
                    <ExpandLessRounded color='primary' style={{ fontSize: 40 }} />
                </IconButton>
                <Drawer anchor={'bottom'} open={footer} onClose={showFooter}>
                    <FooterBar/>
                </Drawer>
            </Hidden>
        </div>
    );
}

export default Footer;